import {i18n} from '@/setup/i18n-setup';
import {IStatus} from "@/constants/interface";

export function lawyerOptions (state) {
  return state.lawyerOptions
    .filter(res => res.status === IStatus.enabled)
    .map(res => {
      return {label: res.fullName, value: res.id, isChoose: res.isChoose}
    })
}

export function prosecutionstatusesOptions (state) {
  return state.prosecutionstatusesOptions
    .map(({value}) =>{
      return {
        label: i18n.t('getters.prosecutionstatusesOptions')[value],
        value,
      }
    })
}

export function prosecutionResultOptions (state) {
  return state.prosecutionResultOptions
    .map(({value}) =>{
      return {
        label: i18n.t('getters.prosecutionResultOptions')[value],
        value,
      }
    })
}


export function caseStatusOptions (state) {
  return state.caseStatusOptions
    .filter(res => !state.disabledCaseStatusOptions.includes(res.value))
    .map(res =>{
    return {
      ...res,
      label: i18n.t('getters.caseStatusOptions')[res.value]
    }
  })
}

export function caseStatusProsecuteCaseOptions (state) {
  return state.caseStatusOptions
    .filter(res => !state.disabledCaseStatusProsecuteCaseOptions.includes(res.value))
    .map(res =>{
      return {
        ...res,
        label: i18n.t('getters.caseStatusOptions')[res.value]
      }
    })
}

export function caseStatusEnforceCaseOptions (state) {
  return state.caseStatusOptions
    .filter(res => !state.disabledCaseStatusEnforceCaseOptions.includes(res.value))
    .map(res =>{
      return {
        ...res,
        label: i18n.t('getters.caseStatusOptions')[res.value]
      }
    })
}

